module.exports = "/packs/media/images/baby-4aee57493e5fdd76732d0d968f4673ba.png";